import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'open-mobile-app-or-prod',
  standalone: true,
  imports: [FormsModule, CommonModule, ButtonModule, RouterModule, TranslateModule],
  template: `
    <div class="bg-[#00205B] flex flex-col items-center justify-center min-h-screen min-w-[100vw] overflow-hidden">
      <img src="assets/svg/menu/logo.svg" alt="Esselunga Logo" class="mb-6 h-[140px] w-[140px] rounded-lg" />
      <h2 style="color: white; word-break: break-all;">{{ 'download.myesse.app.label' | translate }}</h2>
      <br />
      <div class="flex flex-col gap-4 w-full max-w-xs items-center justify-center">
        <p-button class="w-full" (onClick)="openAppStore()">
          <img src="/assets/svg/DownloadOnAppStore.svg" class="w-[350px] h-[80px]" />
        </p-button>
        <p-button class="w-full" (onClick)="openGooglePlay()">
          <img src="/assets/svg/GetItOnGooglePlay.svg" class="w-[350px] h-[80px]" />
        </p-button>
        @if (isDevEnvironment) {
          <span style="color: white; word-break: break-all; text-align: center;">
            {{ 'visit.website.label' | translate }}
            <br />
            <a href="https://myesse.esselunga.it" style="text-decoration: underline;">{{
              'myesse.esselunga.it' | translate
            }}</a></span
          >
        }
      </div>
    </div>
  `,
})
export class OpenMobileAppOrProd {
  appStoreLink: string = 'https://apps.apple.com/us/app/myesse/id6752617157';
  googlePlayLink: string = 'https://play.google.com/store/apps/details?id=it.esselunga.mobile.portaledipendenti';
  isDevEnvironment: boolean = false;

  constructor() {
    this.isDevEnvironment = window.location.href.includes('dev.myportal.esselunga.it');
  }

  openAppStore() {
    window.open(this.appStoreLink, '_blank');
  }

  openGooglePlay() {
    window.open(this.googlePlayLink, '_blank');
  }
}
